import { mount } from '../dom-lifecycle';

mount('[data-prize-variant]', function () {
	const $container = $(this);
	const available = $container.data('available');
	const $sizes = $container.find('[data-ref=size]');
	const $models = $container.find('[data-ref=model]');
	const $input = $container.find('[data-ref=input]');

	$models.on('change', function () {
		const model = this.value;
		$sizes.each(function () {
			this.disabled = !available[model][this.value];
			this.checked = this.disabled ? false : this.checked;
		});
	});
	$sizes.add($models).on('change', function () {
		const model = $models.filter(':checked').val();
		const size = $sizes.filter(':checked').val();
		$input.val(model && size ? available[model][size] : '').trigger('change');
	});
});